 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0d67b4da":"b99d131e","chunk-1ebb4355":"d69b32e9","chunk-078d27e6":"95cca7ae","chunk-5d1cf480":"b5a42143","chunk-5f95fed4":"cbe89308","chunk-85bf8da6":"d3b106f2","chunk-3c214f4c":"7cb80ca7","chunk-4cd5229e":"0873dd54","chunk-70d9a12a":"6ca17a45","chunk-d8c273f4":"f89e0a83","chunk-29112624":"0d71e770","chunk-49dd6e72":"39d141e6","chunk-4ed9cbf1":"8db712fc","chunk-4fd7a544":"5ef53c9b","chunk-7ac3fbeb":"1885b3da","chunk-79494878":"0fc9f85a","chunk-34dfcbd8":"6aa25082","chunk-14d23a1b":"44b6dabd","chunk-29ce3e9a":"ffe73553","chunk-2d22cfbb":"1550e797","chunk-3b6e2e64":"1d89fec4","chunk-f1ac5b94":"21b5f274","chunk-12f92897":"65626e17","chunk-e66c0fa6":"aacd25dc","chunk-154ff6d4":"9ddd20ef","chunk-225668b9":"1b88dad8","chunk-3875e6d9":"a83d2700","chunk-479557da":"71683d4a","chunk-6b097e21":"70169399","chunk-8b87473a":"921b6772","chunk-024e0378":"dd64363d","chunk-11967015":"701c9d06","chunk-35adbb5c":"afb546c6","chunk-4d9ff85e":"c3f4e8fa","chunk-d96a48d0":"8ab281a3","chunk-e8b90096":"ca47a734","chunk-f186663e":"286e80e6","chunk-72a12e66":"78b10759","chunk-1cdf1e5b":"2ddd4559","chunk-4ad4519e":"093f62bb","chunk-2d22ce63":"8fc203b3","chunk-564d7cbc":"38685735","chunk-a0e1e2b6":"c0d65e1e","chunk-61bd7040":"52ce237d","chunk-b05c47e0":"35305847","chunk-54882b56":"7274af51","chunk-1f8568ac":"f4d3b274","chunk-2d0daf13":"d9d8a763","chunk-425d6ee7":"4e0b3d47","chunk-6550b988":"5eefb9af","chunk-05829b82":"dbb7610e","chunk-0b220df3":"85ff658e","chunk-0d8253ff":"6fe60b2a","chunk-4920c2b6":"0d824752","chunk-40ab0aa0":"b1095ffe","chunk-b2d07110":"14bc5796","chunk-688135dd":"a8ee03bd","chunk-22a034a0":"93c34245","chunk-650da5d5":"d4fb7dfd","chunk-e1ce58b6":"99a0b5d6","chunk-39c00ddc":"bb654d97","chunk-f9341636":"b895265b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0d67b4da":1,"chunk-078d27e6":1,"chunk-5d1cf480":1,"chunk-85bf8da6":1,"chunk-3c214f4c":1,"chunk-4cd5229e":1,"chunk-70d9a12a":1,"chunk-d8c273f4":1,"chunk-29112624":1,"chunk-49dd6e72":1,"chunk-4ed9cbf1":1,"chunk-4fd7a544":1,"chunk-7ac3fbeb":1,"chunk-79494878":1,"chunk-34dfcbd8":1,"chunk-14d23a1b":1,"chunk-29ce3e9a":1,"chunk-3b6e2e64":1,"chunk-f1ac5b94":1,"chunk-12f92897":1,"chunk-e66c0fa6":1,"chunk-154ff6d4":1,"chunk-225668b9":1,"chunk-3875e6d9":1,"chunk-479557da":1,"chunk-6b097e21":1,"chunk-8b87473a":1,"chunk-024e0378":1,"chunk-11967015":1,"chunk-35adbb5c":1,"chunk-4d9ff85e":1,"chunk-d96a48d0":1,"chunk-e8b90096":1,"chunk-f186663e":1,"chunk-72a12e66":1,"chunk-1cdf1e5b":1,"chunk-4ad4519e":1,"chunk-564d7cbc":1,"chunk-a0e1e2b6":1,"chunk-61bd7040":1,"chunk-b05c47e0":1,"chunk-54882b56":1,"chunk-1f8568ac":1,"chunk-425d6ee7":1,"chunk-6550b988":1,"chunk-05829b82":1,"chunk-0b220df3":1,"chunk-0d8253ff":1,"chunk-4920c2b6":1,"chunk-40ab0aa0":1,"chunk-b2d07110":1,"chunk-688135dd":1,"chunk-22a034a0":1,"chunk-650da5d5":1,"chunk-e1ce58b6":1,"chunk-39c00ddc":1,"chunk-f9341636":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0d67b4da":"0a6c6bec","chunk-1ebb4355":"31d6cfe0","chunk-078d27e6":"d33c3269","chunk-5d1cf480":"cf4bc019","chunk-5f95fed4":"31d6cfe0","chunk-85bf8da6":"3f0eefd7","chunk-3c214f4c":"25944398","chunk-4cd5229e":"cdb5978d","chunk-70d9a12a":"58b3136d","chunk-d8c273f4":"a666882c","chunk-29112624":"9a4e024a","chunk-49dd6e72":"97b3fd80","chunk-4ed9cbf1":"9f750093","chunk-4fd7a544":"2e8ceb2a","chunk-7ac3fbeb":"52d843c6","chunk-79494878":"73791739","chunk-34dfcbd8":"b9d4b9da","chunk-14d23a1b":"a3785fcd","chunk-29ce3e9a":"9c25ad5e","chunk-2d22cfbb":"31d6cfe0","chunk-3b6e2e64":"2db27da1","chunk-f1ac5b94":"08ff8ce3","chunk-12f92897":"2db27da1","chunk-e66c0fa6":"e7b90658","chunk-154ff6d4":"d6e0c8c4","chunk-225668b9":"17af90f7","chunk-3875e6d9":"03386b22","chunk-479557da":"69ac1cf8","chunk-6b097e21":"7d2e4a18","chunk-8b87473a":"e4aca5eb","chunk-024e0378":"a3785fcd","chunk-11967015":"40f6a5c1","chunk-35adbb5c":"f5e5fd6f","chunk-4d9ff85e":"ae3a69c9","chunk-d96a48d0":"5108f136","chunk-e8b90096":"3b4b99b4","chunk-f186663e":"cdbde18a","chunk-72a12e66":"0d6c2cff","chunk-1cdf1e5b":"044ed031","chunk-4ad4519e":"ec37902b","chunk-2d22ce63":"31d6cfe0","chunk-564d7cbc":"cb9bd679","chunk-a0e1e2b6":"b48f586d","chunk-61bd7040":"3e19cabe","chunk-b05c47e0":"370fb928","chunk-54882b56":"a3785fcd","chunk-1f8568ac":"b48f586d","chunk-2d0daf13":"31d6cfe0","chunk-425d6ee7":"cb9bd679","chunk-6550b988":"546e2d4a","chunk-05829b82":"3715caf2","chunk-0b220df3":"0e547427","chunk-0d8253ff":"5ced9ffd","chunk-4920c2b6":"519636ca","chunk-40ab0aa0":"2c0a9555","chunk-b2d07110":"a6d66f8d","chunk-688135dd":"a3785fcd","chunk-22a034a0":"a2e36f63","chunk-650da5d5":"66cdedab","chunk-e1ce58b6":"57bcb400","chunk-39c00ddc":"3160bdff","chunk-f9341636":"29b327dd"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dayungs_pos/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
